import type { Asserts } from 'yup';

import { contractSchema as campContractSchema } from '@/features/Sparten/campv2/schema/contractSchema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

export const contractSchema = campContractSchema;

export type ContractStore = Asserts<typeof contractSchema>;

export const useCampv2ContractStore = genericStoreFactory(
  () => contractSchema.getDefault() as ContractStore,
  'Campv2ContractStore',
);
